@if (popupMenuItem.enabled) {
  @if (popupMenuItem.separator) {
    <hr />
  }
  @if (popupMenuItem.link) {
    <div
      class="popup-menu-item {{typePopup}}"
      [ngClass]="{'danger': popupMenuItem.danger}"
      routerLink="{{ popupMenuItem.link }}"
      routerLinkActive="active"
      title="{{ text }}"
      (click)="linkClick()"
      >
      <i class="fa-fw {{popupMenuItem.icon}}" [ngClass]="{'danger': popupMenuItem.danger}" aria-hidden="true"></i>
      <span class="text">{{ text }}</span>
    </div>
  } @else {
    <div
      class="popup-menu-item {{typePopup}}"
      [ngClass]="{'danger': popupMenuItem.danger}"
      title="{{ text }}"
      (click)="ctaClick()"
      >
      <i class="fa-fw {{popupMenuItem.icon}}" [ngClass]="{'danger': popupMenuItem.danger}" aria-hidden="true"></i>
      <span class="text">{{ text }}</span>
    </div>
  }
} @else {
  @if (popupMenuItem.separator) {
    <hr />
  }
  <div class="popup-menu-item disabled {{typePopup}}">
    <i class="fa-fw" [ngClass]="popupMenuItem.icon" aria-hidden="true"></i>
    <span class="text">{{ text }}</span>
  </div>
}
